export default __webpack_public_path__ + "0696da6426e32727323462c7e566e2d1.png";